import { colors } from '@dixa/lib-shared-tokens';
export const integrationsApiToken = {
    type: 'integrationsApi',
    version: '1',
    label: 'Integrations API (DEPRECATED)',
    color: colors.green[400],
};
export const dixaApiToken = {
    type: 'dixaApi',
    version: '2',
    label: 'Dixa API',
    color: colors.purple[400],
};
export const apiTokenTypes = [integrationsApiToken, dixaApiToken];
export const apiTokenTypesByVersion = apiTokenTypes.reduce((obj, current) => (Object.assign(Object.assign({}, obj), { [current.version]: current })), {});
